<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Satzung</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Home</a></li>
                        <li>Satzung</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Satzung Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto">
            <h2 class="text-3xl font-bold mb-6 text-center text-gray-800">Satzung von HIGETO e.V.</h2>

            <p class="mb-4 text-gray-700">Hier findest du die wichtigsten Paragraphen aus unserer Vereinssatzung, die am <strong>16.11.2024</strong> einstimmig beschlossen wurde.</p>

            <ul class="space-y-4 list-disc pl-6 text-gray-700">
                <li><strong>§1:</strong> Name, Sitz, Geschäftsjahr – HIGETO e.V., Sitz in Hildesheim, Geschäftsjahr = Kalenderjahr</li>
                <li><strong>§2:</strong> Vereinszweck – Gesundheitsförderung, Bildung, Trinkwasserzugang, Umweltschutz, Kultur & Entwicklungszusammenarbeit</li>
                <li><strong>§3:</strong> Gemeinnützigkeit – Selbstlos, keine wirtschaftlichen Zwecke, keine persönliche Bereicherung</li>
                <li><strong>§5:</strong> Mitgliedschaft – Für natürliche & juristische Personen, Mitgliedsbeitrag: 20 € jährlich</li>
                <li><strong>§6–7:</strong> Organe – Mitgliederversammlung & Vorstand</li>
                <li><strong>§8:</strong> Vorstand – Besteht aus 1. Vorsitzenden, 2. Vorsitzenden & Schatzmeister/in</li>
                <li><strong>§13:</strong> Auflösung – Beschluss durch die Mitgliederversammlung möglich, Vermögen wird gemeinnützig übertragen</li>
            </ul>

            <div class="mt-8 text-center">
                <a href="assets/docs/satzung.pdf" target="_blank" class="default-btn">
                    Satzung als PDF herunterladen
                </a>
            </div>
        </div>
    </div>
</section>
<app-subscribe></app-subscribe>
